/**
 * @generated SignedSource<<aab9afdb2d6e2411d0c662272da82047>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AllUsersShortQuery$variables = {
  filter_flexible?: string | null | undefined;
  first?: number | null | undefined;
  page?: number | null | undefined;
};
export type AllUsersShortQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AllUserShortListFragment">;
};
export type AllUsersShortQuery = {
  response: AllUsersShortQuery$data;
  variables: AllUsersShortQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter_flexible"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v3 = [
  {
    "kind": "Variable",
    "name": "filter_flexible",
    "variableName": "filter_flexible"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "field",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "display",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type_decode",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AllUsersShortQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "kind": "FragmentSpread",
        "name": "AllUserShortListFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AllUsersShortQuery",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "UserConnection",
        "kind": "LinkedField",
        "name": "allUsers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "first_name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "last_name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "phone",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Structure",
            "kind": "LinkedField",
            "name": "structure",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "editable",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Structure",
                "kind": "LinkedField",
                "name": "nest",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Structure",
                    "kind": "LinkedField",
                    "name": "nest",
                    "plural": true,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Structure",
                        "kind": "LinkedField",
                        "name": "nest",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Structure",
                            "kind": "LinkedField",
                            "name": "nest",
                            "plural": true,
                            "selections": [
                              (v4/*: any*/),
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Structure",
                                "kind": "LinkedField",
                                "name": "nest",
                                "plural": true,
                                "selections": [
                                  (v4/*: any*/),
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "count",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "filters": [
          "page",
          "filter_flexible"
        ],
        "handle": "connection",
        "key": "UserFragment_allUsers",
        "kind": "LinkedHandle",
        "name": "allUsers"
      }
    ]
  },
  "params": {
    "cacheID": "ba5cc3a7358d531c08afe22df894a1be",
    "id": null,
    "metadata": {},
    "name": "AllUsersShortQuery",
    "operationKind": "query",
    "text": "query AllUsersShortQuery(\n  $first: Int\n  $page: Int\n  $filter_flexible: String\n) {\n  ...AllUserShortListFragment_zuKIu\n}\n\nfragment AllUserShortListFragment_zuKIu on Query {\n  allUsers(page: $page, first: $first, filter_flexible: $filter_flexible) {\n    edges {\n      cursor\n      node {\n        ...UserShortFragment\n        id\n        __typename\n      }\n    }\n    ...UserShortConnectionFragment\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment PageInfoFragment on PageInfo {\n  count\n}\n\nfragment StructureFragment on Structure {\n  field\n  type\n  display\n  type_decode\n  editable\n  nest {\n    field\n    type\n    display\n    type_decode\n    nest {\n      field\n      type\n      display\n      type_decode\n      nest {\n        field\n        type\n        display\n        type_decode\n        nest {\n          field\n          type\n          display\n          type_decode\n          nest {\n            field\n            type\n            display\n            type_decode\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment UserShortConnectionFragment on UserConnection {\n  edges {\n    cursor\n    node {\n      ...UserShortFragment\n      id\n    }\n  }\n  structure {\n    ...StructureFragment\n  }\n  pageInfo {\n    ...PageInfoFragment\n  }\n}\n\nfragment UserShortFragment on User {\n  id\n  first_name\n  last_name\n  email\n  phone\n}\n"
  }
};
})();

(node as any).hash = "6f7f400469c261e09b44f1b4353d22b3";

export default node;
